import { UserPreferences } from "../../../interfaces/UserObject";
import genericUtility from "../../utility/GenericUtility";
import { AppConstants } from "../../../constants/AppConstants";

const DEFAULT_HYPER_LOCAL_DISTANCE_KM = 0.2;

/**
 * Generic, location-aware search payload shared by product, profile and
 * (future) business search. Keep this free of any domain-specific fields so
 * every search scope can reuse it.
 */
function buildSearchPayload(
  searchString: string,
  userPreferences: UserPreferences
) {
  const userLocation = genericUtility.resolveUserLocation(userPreferences);
  return {
    searchString,
    latitude: userLocation?.userLatitude,
    longitude: userLocation?.userLongitude,
    radius: AppConstants.DEFAULT_USER_PREFERENCES.searchRadius,
    sortBy: userPreferences.searchSortBy,
    hyperLocalEnabled: userPreferences.isHyperLocalEnabled,
    hyperLocalDistance: userPreferences.hyperLocalDistance
      ? userPreferences.hyperLocalDistance / 1000
      : DEFAULT_HYPER_LOCAL_DISTANCE_KM,
  };
}

const SearchConvertor = { buildSearchPayload };
export default SearchConvertor;
